import { SimpleGrid, Container, Center, Loader, Code } from "@mantine/core";
import StyleCard from "./StyleCard";
import { useEffect, useState } from "react";
import { getStyles } from "../api";

export default function StyleList() {
  const [styles, setStyles] = useState(null);

  useEffect(() => {
    getStyles().then((data) => {
      setStyles(data);
    });
  }, []);

  if (!styles)
    return (
      <Container fluid>
        <Center>
          <Loader mt="xl" size="xl" />
        </Center>
      </Container>
    );

  return (
    <Container fluid>
      <SimpleGrid
        pt="lg"
        type="container"
        cols={{
          base: 1,
          "600px": 2,
          "1000px": 3,
          "1400px": 4,
          "1750px": 5,
          "2100px": 6,
        }}
      >
        {styles.map((style) => (
          <>
          {/* <Code block>{JSON.stringify(style, null, 2)}</Code> */}
          <StyleCard key={style.id} style={style} />
          </>
        ))}
      </SimpleGrid>
    </Container>
  );
}
